<nav class="navbar navbar-expand-lg navbar-light bg-light">
	<a class="navbar-brand" href="#">
		<img src="assets/images/abdp.png" alt="ABDP" />
	</a>

	<button *ngIf="this.isConnected()" class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbar" aria-controls="navbar" aria-expanded="false" aria-label="Navigation">
		<span class="navbar-toggler-icon"></span>
	</button>

	<div class="collapse navbar-collapse" id="navbar">
		<ul class="navbar-nav mr-auto">
			<li class="nav-item active" routerLinkActive="active" *ngIf="this.isConnected()">
				<a class="nav-link" routerLink="/">Tableau de bord</a>
			</li>
			<li class="nav-item dropdown" *ngIf="this.isConnected() && this.isAdmin()">
				<a class="nav-link dropdown-toggle" href="#" id="navbarAdministation" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Administation</a>
				<div class="dropdown-menu" aria-labelledby="navbarAdministation">
					<a routerLink="folder-list" class="dropdown-item material-item"><i class="material-icons md-18 icons">folder</i> Gestion des dossiers</a>
					<div class="dropdown-divider"></div>
					<a routerLinkActive="active" routerLink="company-list" class="dropdown-item material-item"><i class="material-icons md-18 icons">apartment</i> Gestion des sociétés</a>
					<a routerLinkActive="active" routerLink="user-list" class="dropdown-item material-item"><i class="material-icons md-18 icons">person</i> Gestion des utilisateurs</a>
				</div>
			</li>
		</ul>

		<!-- Right menu -->
		<ul class="navbar-nav ml-auto" *ngIf="this.isConnected()">
			<li class="nav-item dropdown mr-3">
				<a class="nav-link dropdown-toggle" href="#" id="navbarMyAccount" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Mon compte</a>
				<div class="dropdown-menu" aria-labelledby="navbarMyAccount">
					<a routerLink="my-account" class="dropdown-item material-item"><i class="material-icons md-18 icons">account_circle</i> Mes données</a>
					<a routerLink="my-password" class="dropdown-item material-item"><i class="material-icons md-18 icons">vpn_key</i> Mon mot de passe</a>
				</div>
			</li>
			<li class="nav-item mr-3">
				<a matTooltip="Déconnexion" routerLink="logout" class="dropdown-item material-item align-middle pl-0 pr-0" href="#"><i class="material-icons md-18 mv-0 icons">lock_open</i> Déconnexion</a>
			</li>
		</ul>
  </div>
</nav>
<br />

<router-outlet></router-outlet>
